
import { mapActions, mapState, mapGetters } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
import PairNowSvg from "~/assets/images/PairNowForMobile.svg";
import AnimatedCheckMark from "../common/animated-check-mark.vue";
export default {
  components: { ResponsiveDialog, AnimatedCheckMark },
  props: {
    dialog: false,
    title: {
      type: String,
      default: ""
    },
    classProp: {
      type: String,
      default: "white--text text-none my-md-4 my-2"
    },

    content: {
      type: String,
      default:
        "Awesome! You’re all set to pair your online food delivery platforms with Foaps and start receiving all your online orders seamlessly from one place."
    },
    buttonText: {
      type: String,
      default: "Pair Now"
    },
    buttonColor: {
      type: String,
      default: "#F55028"
    },
    isCheckmarkEnabled: {
      type: Boolean,
      default: false
    },
    isOutlined: {
      type: Boolean
    },
    isMoveToHome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      PairNowSvg
    };
  },
  methods: {
    handleClick() {
      if (this.$vuetify.breakpoint.smAndDown && !this.isMoveToHome) {
        this.$router.push(`/settings/channel-manager`);
      } else {
        this.$router.push("/reciever");
      }
      this.$emit("close-dialog");
    }
  }
};
